import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Row, Col, Button, Badge } from "antd";
import { MessageOutlined, ReloadOutlined } from "@ant-design/icons";
import { getSolicitudes, reloadAllSilencioso } from "../../context/actions/atencionActions";
import { useAtencionFilters } from "../../hooks/useAtencionFilters";
import { BusquedaSolicitudes } from "./filtros/BusquedaSolicitudes";
import { ListaSolicitudes } from "./lista/ListaSolicitudes";
import { ModalChat } from "./chat/ModalChat";
import "./utils/atencion.css";

export const Atencion = () => {
  const dispatch = useDispatch();
  const {
    filteredData,
    loading,
    contadores,
    filtros,
    opcionesEstados,
    actualizarFiltro,
    limpiarFiltros,
    handleStatusFilterClick,
    handleNoLeidosFilterClick,
    handleTotalFilterClick
  } = useAtencionFilters();

  const [modalChat, setModalChat] = useState({ visible: false, solicitud: null });

  useEffect(() => {
    dispatch(getSolicitudes());
  }, [dispatch]);

  const handleOpenChat = (solicitud) => {
    setModalChat({ visible: true, solicitud });
  };

  const handleCloseChat = () => {
    setModalChat({ visible: false, solicitud: null });
  };

  const handleRefresh = () => {
    dispatch(reloadAllSilencioso());
  };

  const handleContadorClick = (tipo) => {
    switch (tipo) {
      case 'total':
        handleTotalFilterClick();
        break;
      case 'abiertas':
        handleStatusFilterClick('abierto');
        break;
      case 'cerradas':
        handleStatusFilterClick('cerrado');
        break;
      case 'noLeidas':
        handleNoLeidosFilterClick();
        break;
      default:
        handleTotalFilterClick();
    }
  };

  return (
    <div className="atencion-view">
      {/* header */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <MessageOutlined style={{ fontSize: 24, color: 'var(--color-naranja)' }} />
            <div>
              <h2 style={{ margin: 0, fontSize: 20, fontWeight: 600 }}>
                Atención al cliente
              </h2>
              {/* <p style={{ margin: 0, color: '#666', fontSize: 14 }}>
                Gestión de solicitudes de todos los proveedores
              </p> */}
            </div>
          </div>
        </Col>
      </Row>

      {/* contadores interactivos */}
      <Row gutter={16} style={{ marginBottom: 24 }}>
        <Col span={6}>
          <div 
            className={`contador-card ${!filtros.estado && !filtros.soloNoLeidos ? 'active' : ''}`} 
            onClick={() => handleContadorClick('total')} 
            title="Ver todas las solicitudes"
          >
            <div className="contador-numero">{contadores.total}</div>
            <div className="contador-label">Total</div>
          </div>
        </Col>
        <Col span={6}>
          <div 
            className={`contador-card ${filtros.estado === 'abierto' ? 'active' : ''}`} 
            onClick={() => handleContadorClick('abiertas')} 
            title="Filtrar solicitudes abiertas"
          >
            <div className="contador-numero" style={{ color: '#52c41a' }}>
              {contadores.abiertas}
            </div>
            <div className="contador-label">Abiertas</div>
          </div>
        </Col>
        <Col span={6}>
          <div 
            className={`contador-card ${filtros.estado === 'cerrado' ? 'active' : ''}`} 
            onClick={() => handleContadorClick('cerradas')} 
            title="Filtrar solicitudes cerradas"
          >
            <div className="contador-numero" style={{ color: '#8c8c8c' }}>
              {contadores.cerradas}
            </div>
            <div className="contador-label">Cerradas</div>
          </div>
        </Col>
        <Col span={6}>
          <div 
            className={`contador-card ${filtros.soloNoLeidos ? 'active' : ''}`} 
            onClick={() => handleContadorClick('noLeidas')} 
            title="Filtrar solicitudes no leídas"
          >
            <div className="contador-numero">
              <Badge 
                count={contadores.noLeidas} 
                style={{ backgroundColor: 'var(--color-naranja)' }}
              >
                <span style={{ color: 'var(--color-naranja)' }}>
                  {contadores.noLeidas}
                </span>
              </Badge>
            </div>
            <div className="contador-label">No leídas</div>
          </div>
        </Col>
      </Row>

      {/* filtros de búsqueda */}
      <BusquedaSolicitudes
        filtros={filtros}
        onFiltroChange={actualizarFiltro}
        onActualizar={handleRefresh}
      />

      {/* lista/tabla de solicitudes */}
      <ListaSolicitudes
        onOpenChat={handleOpenChat}
        filteredData={filteredData}
        loading={loading}
        filtros={filtros}
        limpiarFiltros={limpiarFiltros}
      />

      {/* modal chat */}
      <ModalChat
        visible={modalChat.visible}
        solicitud={modalChat.solicitud}
        onClose={handleCloseChat}
      />
    </div>
  );
};

export default Atencion;